import type { TOC } from '@ember/component/template-only';
import { array, fn } from '@ember/helper';
import { on } from '@ember/modifier';

import joinClasses from 'webapp/helpers/join-classes';
import type { ShownOption } from 'webapp/components/goals/target-type-and-granulation/popup';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface TargetTypeAndGranulationListItemComponentInterface {
	Args: {
		model: ShownOption;
		isSelected: boolean;
		onSelect: (model: ShownOption) => void;
	};
}
const TargetTypeAndGranulationListItemComponent: TOC<TargetTypeAndGranulationListItemComponentInterface> =
	<template>
		<li
			class={{joinClasses
				(array (if @isSelected "selected") (if @model.isSeparated "separator"))
			}}
		>
			<a class="item-title" {{on "click" (fn @onSelect @model)}}>
				{{@model.label}}
			</a>
			{{#if @model.tooltipText}}
				<ToolTipWithIconComponent @text={{@model.tooltipText}} @maxWidth={{230}} />
			{{/if}}
		</li>
	</template>;

export default TargetTypeAndGranulationListItemComponent;
